import { render, staticRenderFns } from "./TenancyDepositReleaseConfirmation.vue?vue&type=template&id=f9242b22&"
import script from "./TenancyDepositReleaseConfirmation.vue?vue&type=script&lang=js&"
export * from "./TenancyDepositReleaseConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports